import { inject, Service } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { map } from "rxjs/operators";

import { noWhitespaceValidator } from "../../core/validators";
import type { MainResponseModel } from "../models";
import type { ValidatorModelType } from "../models/validator-model";
import { MainService } from "./main-service";

@Service()
export class ValidatorApiService {
  private _mainService = inject(MainService);

  public searchByKey(key: string, mandatory: boolean = true) {
    let url = `validator/getbysearchkeyv2/${key}`;
    if (mandatory) url += "?mandatory=y";

    return this._mainService.sendRequest<MainResponseModel<ValidatorModelType>>({
      url,
      method: "GET",
      loader: true,
    });
  }

  public applyValidationToForm(key: string, form: FormGroup) {
    return this.searchByKey(key).pipe(
      map((response) => {
        response?.responseData?.parameterCatalogs?.forEach((parameter) => {
          const control = form.get(parameter.fieldName);

          if (control) {
            const existingValidators = control.validator ? [control.validator] : [];
            control.setValidators([...existingValidators, Validators.required, noWhitespaceValidator()]);
            control.updateValueAndValidity();
          }
        });

        return { form, validation: response.responseData ?? {} };
      })
    );
  }

  public setValidationFromData(validation: ValidatorModelType, form: FormGroup) {
    validation?.parameterCatalogs?.forEach((parameter) => {
      const control = form.get(parameter.fieldName);

      if (control) {
        const existingValidators = control.validator ? [control.validator] : [];
        control.setValidators([...existingValidators, Validators.required, noWhitespaceValidator()]);
        control.updateValueAndValidity();
      }
    });

    return form;
  }

  public isFormValid(form: FormGroup, isFinished = true, fields = ["nameAE", "nameEN"]): boolean {
    if (!isFinished) {
      fields.forEach((field) => form.get(field)?.markAsTouched({ onlySelf: true }));
      return fields.every((field) => form.get(field)?.valid);
    }

    form.markAllAsTouched();
    return form.valid;
  }
}
